import styled from 'styled-components';

export const IconSVG = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
`;
